.canvas {
  background-color: var(--gray-F7F8FA);
  flex: 1;
  height: 100%;
}
